import React from 'react';
import EditProfileForm from './EditProfileForm';
import ChangePasswordForm from './ChangePassword';
import './MyProfile.css'; 

const MyProfilePage = () => {
    return (
        <div className="main-content">
            <div className="profile-page-wrapper">
                <div className="container">
                    {/* <h2 className="profile-title text-center">Account Settings</h2> */}
                    <div className="row g-4">
                        {/* Left Column: Edit Profile */}
                        <div className="col-lg-7">
                            <EditProfileForm />
                        </div>

                        {/* Right Column: Change Password */}
                        <div className="col-lg-5">
                            <ChangePasswordForm />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyProfilePage;